import axiosInstance from './../axiosInstance';

/**
 * @name getUser
 * @desc Get single user.
 * @param {object} credentials
 */
export const getUser = userID => {
	return axiosInstance.get('users/' + userID);
};

/**
 * @name saveUser
 * @desc Save single user.
 * @param {object} credentials
 */
export const saveUser = (userID, data) => {
	return axiosInstance.post('users/' + userID, data);
};

/**
 * @name createPartnerUser
 * @desc Create single user
 * @param {object} data
 */
export const createPartnerUser = data => {
	return axiosInstance.post('users/', data);
};

/**
 * 
 * @name linkPartnerUser
 * @desc Link existing user to partner
 * @param {object} data 
 */
export const linkUserToPartner = data => {
	return axiosInstance.post('users/linkUserToPartner', data);
}

/**
 * 
 * @name deletePartnerUser
 * @desc Delete partner user
 * @param { object } data
 */
export const deletePartnerUser = ({ partnerID, email }) => {
	const deletePartner = {
		partnerID,
		email,
		timeDeleted: true
	};
	return axiosInstance.post('users/linkUserToPartner', deletePartner);
}

export const changeOrganization = organizationID => {
	return axiosInstance.post('users/changeOrganization', { organizationID });
}

export const checkIfUserExists = email => {
	return axiosInstance.post('users/checkEmail', { email })
}